import { render, staticRenderFns } from "./EmitirMdfeDialog.vue?vue&type=template&id=37bff4b2&scoped=true"
import script from "./EmitirMdfeDialog.vue?vue&type=script&lang=js"
export * from "./EmitirMdfeDialog.vue?vue&type=script&lang=js"
import style0 from "./EmitirMdfeDialog.vue?vue&type=style&index=0&id=37bff4b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bff4b2",
  null
  
)

export default component.exports